// Iter 204i — Terminal 2.0 pill-style mode toggle.
//
// Sits at the top-right next to the theme toggle.  Persists choice in
// localStorage via `useDesignMode()`.  Renders distinct iconography
// per mode and a subtle amber glow when terminal mode is active.
import { Sparkles, LayoutGrid } from "lucide-react";
import { useDesignMode } from "../../context/DesignModeContext";

export default function DesignModeToggle({ className = "" }) {
  const { mode, toggle } = useDesignMode();
  const isTerminal = mode === "terminal";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="design-mode-toggle"
      aria-label={`Switch to ${isTerminal ? "classic" : "terminal 2.0"} design`}
      className={`group flex items-center gap-1.5 px-2.5 py-1 rounded-full border transition-all ${
        isTerminal
          ? "border-amber-400/60 bg-amber-500/10 text-amber-300 shadow-[0_0_12px_rgba(245,165,36,0.30)]"
          : "border-border bg-card/40 text-muted-foreground hover:border-foreground/40"
      } ${className}`}
    >
      {isTerminal ? <Sparkles className="w-3.5 h-3.5" /> : <LayoutGrid className="w-3.5 h-3.5" />}
      <span className="text-[10px] uppercase tracking-[0.16em] font-bold font-mono whitespace-nowrap">
        {isTerminal ? "2.0 Terminal" : "Classic"}
      </span>
      <span
        aria-hidden
        className={`w-1.5 h-1.5 rounded-full ${
          isTerminal
            ? "bg-amber-400 shadow-[0_0_6px_rgba(245,165,36,0.9)]"
            : "bg-muted-foreground/60"
        }`}
      />
    </button>
  );
}
